import { IconButton, InputAdornment, useTheme } from "@mui/material"
import React from "react"
import PropTypes from "prop-types"
import { StyledTextField } from "./Input.styled"

const InputWithIcon = ({
    type = "text",
    label,
    startIcon,
    endIcon,
    onEndIconClick = () => {},
    error = false,
    helperText = "",
    value,
    ...props
}) => {
    const theme = useTheme()

    const [focus, setFocus] = React.useState(false)

    return (
        <StyledTextField
            fullWidth
            type={type}
            label={label}
            error={error}
            value={value}
            variant="filled"
            onFocus={() => {
                setFocus(true)
            }}
            onBlur={() => {
                setFocus(false)
            }}
            helperText={error ? helperText : undefined}
            InputLabelProps={{ shrink: Boolean(value) || focus }}
            InputProps={{
                startAdornment: startIcon && (
                    <InputAdornment position="start">
                        {React.cloneElement(startIcon, {
                            style: {
                                width: 24,
                                height: 24,
                            },
                        })}
                    </InputAdornment>
                ),
                endAdornment: endIcon && (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={onEndIconClick}
                            edge="end"
                            size="small"
                        >
                            {React.cloneElement(endIcon, {
                                style: {
                                    color: theme.palette.icon.main,
                                    width: 24,
                                    height: 24,
                                },
                            })}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            {...props}
        />
    )
}

InputWithIcon.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    value: PropTypes.string,
    startIcon: PropTypes.element,
    endIcon: PropTypes.element,
    onEndIconClick: PropTypes.func,
    error: PropTypes.bool,
    helperText: PropTypes.string,
}

export default InputWithIcon
